import { render, staticRenderFns } from "./b2b-list-item-subtitle.vue?vue&type=template&id=57dc5402&functional=true"
import script from "./b2b-list-item-subtitle.vue?vue&type=script&lang=js"
export * from "./b2b-list-item-subtitle.vue?vue&type=script&lang=js"
import style0 from "./b2b-list-item-subtitle.vue?vue&type=style&index=0&id=57dc5402&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports